import { type OrderDetailsState } from '../../types';

type ValidateFn = (
  currentStep: number,
  orderDetails: OrderDetailsState,
  hasAvailableCostCenters: boolean,
) => boolean;

const validateStep1 = (details: OrderDetailsState) =>
  !!details.user && !!details.selectedHierarchy?.rootId;

const validateStep2 = (details: OrderDetailsState) =>
  validateStep1(details) && !!details.invoiceRecipient;

const validateStep3 = (details: OrderDetailsState) =>
  validateStep1(details) && validateStep2(details) && details.terms;

const validateOrderDetails: ValidateFn = (step, details, hasAvailableCostCenters) => {
  switch (step) {
    case 1:
      return validateStep1(details);
    case 2:
      return hasAvailableCostCenters && validateStep2(details);
    case 3:
      return hasAvailableCostCenters && validateStep3(details);
    default:
      return true;
  }
};

export default validateOrderDetails;
